module.exports = __webpack_public_path__ + "css/dark.08039fd9.css";